<template>
    <el-dialog title="数据查重" :visible.sync="isShow" :before-close="handleClose" width="70%">
        <el-form :model="searchModel" ref="form" :inline="true" label-width="80px">
            <el-form-item label="客户名称">
                <el-input v-model="searchModel.name" :clearable="true" placeholder="输入客户名称快速检索"></el-input>
            </el-form-item>
            <DistrictLinkage
                    ref="DistrictLinkage"
                    :provinceId="parseInt(searchModel.province_id)"
                    :cityId="parseInt(searchModel.city_id)"
                    :districtId="parseInt(searchModel.district_id)"
                    @change="handleChange"
            ></DistrictLinkage>
            <el-form-item label="查重范围">
                <el-select v-model="searchModel.range">
                    <el-option  label="线索和客户" value=""></el-option>
                    <el-option  label="仅客户" value="1"></el-option>
                    <el-option  label="仅线索" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否绑定">
                <el-select v-model="searchModel.is_bind" placeholder="请选择">
                    <el-option label="不限" value=""></el-option>
                    <el-option label="已绑定" :value="1"></el-option>
                    <el-option label="未绑定" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
            <el-button type="primary" @click="submitSearch" size="small" icon="el-icon-search">搜 索</el-button>
            </el-form-item>
        </el-form>

        <el-table
                :data="results"
                border style="width: 100%"
                max-height="500"
                height="500"
                v-loading="loading"
                highlight-current-row
        >
            <el-table-column prop="type_name" label="类型"></el-table-column>
            <el-table-column prop="customer_name" label="客户名称">
                <template slot-scope="scope">
                    <span v-if="scope.row.type == 1">
                        <span v-if="scope.row.user_id == 0">{{scope.row.customer_name}} <i style="color: #F56C6C;">(未绑定)</i></span>
                        <span v-else>{{scope.row.customer_name}} <i style="color: #F56C6C;">(已绑定)</i></span>
                    </span>
                    <span v-if="scope.row.type == 2">
                         <span v-if="scope.row.user_id == 0 && scope.row.unbind_at==0">{{scope.row.customer_name}} <i style="color: #F56C6C;">(待分配)</i></span>
                         <span v-else-if="scope.row.user_id == 0">{{scope.row.customer_name}} <i style="color: #F56C6C;">(未绑定)</i></span>
                        <span v-else>{{scope.row.customer_name}} <i style="color: #F56C6C;">(已绑定)</i></span>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="申请/创建时间"></el-table-column>
            <el-table-column prop="products" label="申请/已购产品"></el-table-column>
            <el-table-column prop="last_trace_at" label="最后跟进时间"></el-table-column>
             <el-table-column prop="district_names" label="所在地区">
                 <template slot-scope="scope">
                    <i v-if="scope.row.is_lock == 1" class="el-icon-lock" style="color: rgb(239 6 6); margin-left: 5px;"></i>
                     <span>{{ scope.row.district_names }}</span>
                 </template>
             </el-table-column>
            <el-table-column prop="branch_name" label="所属部门"></el-table-column>
            <el-table-column prop="username" label="业务员"></el-table-column>
         <el-table-column prop="cooperator" label="协作人">
             <template slot-scope="scope">
                 <div v-if="scope.row.cooperator">
                     <span v-for="(coop, key) in scope.row.cooperator" :key="key">
                         {{ coop.name }}
                         <span v-if="Object.keys(scope.row.cooperator).indexOf(key) < Object.keys(scope.row.cooperator).length - 1"><br> </span>
                     </span>
                 </div>
                 <span v-else>-</span>
             </template>
         </el-table-column>
            <el-table-column prop="bind_at" label="绑定时间"></el-table-column>
             <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>

    </el-dialog>
</template>

<script>
    import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
    import ClueService from "~/services/SaleClues";

    export default {
        name: "QueryRepeat",
        components: {
            DistrictLinkage,
        },
        data() {
            return {
                isShow: false,
                loading: false,
                results: [],
                searchModel: {
                    name: '',
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                    range: '',
                    is_bind: ''
                }
            }
        },
        created() {
            this.isShow = this.display;
        },
        props: {
            display: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        watch: {
            display: function (value, origin) {
                this.isShow = value;
            }
        },
        methods: {
            // 关闭窗口
            handleClose() {
                this.close();
            },

            // 关闭当前窗口
            close() {
                this.isShow = false;
                // 往上层组件传递更改后的状态
                this.$emit("watchQueryRepeatClose", this.isShow);
            },

            getQueryRepeatResults(params) {
                this.loading = true;
                ClueService.queryRepeat(params).then(res => {
                    if (res.code == 0 && res.data) {
                        this.results = res.data;
                    }
                    this.loading = false;
                })
            },

            submitSearch() {
                const params = { ...this.searchModel };
                if (params.is_bind === '') {
                    delete params.is_bind;
                }
                this.getQueryRepeatResults(params);
            },

            //地区联动 Cascader 级联选择器,切换事件,表单model赋值
            handleChange(value) {
                this.searchModel.province_id = parseInt(value[0]);
                this.searchModel.city_id = parseInt(value[1]);
                this.searchModel.district_id = parseInt(value[2]);
            },
            // 查看、编辑、删除、绑定、转交销售线索操作
            handleView(clue) {
                let path = "/sales-leads/view"
                if(clue.hasOwnProperty('type') && clue.type==1){
                    path = "/customers/view"
                }
                let routeData = this.$router.resolve({
                    path: path,
                    query: { id: clue.id, referer: this.$route.path },
                });
                window.open(routeData.href, '_blank');
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/clue/dialog/QueryRepeat.vue